<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import { swal } from "../../../helpers/handle_error.js";
import {
  required,
  minLength,
  maxLength,
  numeric,
  requiredIf,
} from "vuelidate/lib/validators";
import { fileSize, fileType } from "../../../helpers/validators_files";
import { mapMutations } from "vuex";
import accommodation from "../../../helpers/list/accommodation";
import certificate from "../../../helpers/list/certificate";
import city from "../../../helpers/list/city";
import marital_status from "../../../helpers/list/marital_status";
import relative_relation from "../../../helpers/list/relative_relation";
import gender from "../../../helpers/list/gender";

export default {
  components: { DatePicker },
  props: {},
  data() {
    return {
      fields: [],

      //lists
      list_accommodation: accommodation,
      list_certificate: certificate,
      list_city: city,
      list_marital_status: marital_status,
      list_relative_relation: relative_relation,
      list_gender: gender,
    };
  },
  validations: {
    fields: {
      $each: {
        id_type: { required },
        name1: { required, minLength: minLength(2), maxLength: maxLength(15) },
        name2: { required, minLength: minLength(2), maxLength: maxLength(15) },
        name3: { required, minLength: minLength(2), maxLength: maxLength(15) },
        name4: { required, minLength: minLength(2), maxLength: maxLength(15) },
        family_name: { required, minLength: minLength(2), maxLength: maxLength(15) },
        mother_name: { required, minLength: minLength(2), maxLength: maxLength(50) },
        birth_date: { required },
        certificate_id: { required },
        specialization: { required, minLength: minLength(2), maxLength: maxLength(50) },
        phone1: { required, minLength: minLength(11), maxLength: maxLength(11) },
        phone2: { minLength: minLength(11), maxLength: maxLength(11) },
        relative_relation_id: { required },
        gender_id: { required },
        marital_status_id: { required },

        accommodation_id: { required },
        region: { required, minLength: minLength(2), maxLength: maxLength(50) },
        city_id: { required },
        nearest_point: { required, minLength: minLength(2), maxLength: maxLength(50) },
        mahla: { maxLength: maxLength(10) },
        zqaq: { maxLength: maxLength(10) },
        dar: { maxLength: maxLength(10) },

        nationality_number: {
          required: requiredIf(function (x) {
            return x.id_type == "1";
          }),
          minLength: minLength(12),
          maxLength: maxLength(12),
        },
        national_id_number: {
          required: requiredIf(function (x) {
            return x.id_type == "2";
          }),
          numeric,
          minLength: minLength(8),
          maxLength: maxLength(8),
        },
        attachment_beneficiary: {
          required,
          fileType: fileType("application/pdf"),
          fileSize: fileSize(1024 * 1024 * 2),
        },
      },
    },
    form: ["fields"],
  },
  methods: {
    ...mapMutations("beneficiaries", ["setBeneficiaries"]),
    getNationalityNumber(index) {
      return this.fields[index].id_type == "1";
    },
    getNationalIdNumber(index) {
      return this.fields[index].id_type == "2";
    },
    //  Push the row in form
    AddformDataS() {
      this.fields.push({
        id_type: "1",
        name1: "",
        name2: "",
        name3: "",
        name4: "",
        family_name: "",
        mother_name: "",
        birth_date: "",
        certificate_id: "",
        specialization: "",
        phone1: "",
        phone2: "",
        relative_relation_id: "",
        gender_id: "",
        national_id_number: "",
        nationality_number: "",
        marital_status_id: "",

        accommodation_id: "",
        region: "",
        city_id: "",
        nearest_point: "",
        mahla: "",
        zqaq: "",
        dar: "",

        attachment_beneficiary: "",
      });
    },
    // Delete the row
    async deleteRowS(index) {
      if (await swal.confirm()) {
        this.fields.splice(index, 1);
      }
    },
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      //add beneficiaries to list in next tab.
      if (isValid) {
        this.setBeneficiaries(this.fields);
      }
      return isValid;
    },
    chnageFile(e) {
      e = e.target;
      let index = e.getAttribute("data-index");
      this.fields[index][e.id] = e.files.length > 0 ? e.files[0] : null;
    },
  },
  created() {
    this.AddformDataS();
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">بيانات المستفيد</h5></div>
      <ul class="li-attachments">
        <li>يجب ادخال المستفيدين المذكورين في القسام الشرعي فقط .</li>
      </ul>

      <form class="repeater" enctype="multipart/form-data">
        <div v-for="(field, index) in $v.fields.$each.$iter" :key="field.id" class="">
          <div class="row">
            <b-form-group class="col-md-3 mb-3" label="الاسم : " label-for="name1">
              <b-form-input
                id="name1"
                type="text"
                placeholder="ادخل الاسم"
                v-model.trim="field.name1.$model"
                :class="{ 'is-invalid': field.name1.$error }"
              ></b-form-input>
              <div v-if="field.name1.$error" class="invalid-feedback">
                <span v-if="!field.name1.required">هذا الحقل الزامي</span>
                <span v-if="!field.name1.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name1.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label="اسم الاب : " label-for="name2">
              <b-form-input
                id="name2"
                type="text"
                placeholder="ادخل اسم الاب"
                v-model.trim="field.name2.$model"
                :class="{ 'is-invalid': field.name2.$error }"
              ></b-form-input>
              <div v-if="field.name2.$error" class="invalid-feedback">
                <span v-if="!field.name2.required">هذا الحقل الزامي</span>
                <span v-if="!field.name2.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name2.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label="اسم الجد : " label-for="name3">
              <b-form-input
                id="name3"
                type="text"
                placeholder="ادخل اسم الجد"
                v-model.trim="field.name3.$model"
                :class="{ 'is-invalid': field.name3.$error }"
              ></b-form-input>
              <div v-if="field.name3.$error" class="invalid-feedback">
                <span v-if="!field.name3.required">هذا الحقل الزامي</span>
                <span v-if="!field.name3.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name3.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label="اسم اب الجد : " label-for="name4">
              <b-form-input
                id="name4"
                type="text"
                placeholder="ادخل اسم اب الجد"
                v-model.trim="field.name4.$model"
                :class="{ 'is-invalid': field.name4.$error }"
              ></b-form-input>
              <div v-if="field.name4.$error" class="invalid-feedback">
                <span v-if="!field.name4.required">هذا الحقل الزامي</span>
                <span v-if="!field.name4.minLength"
                  >يجب أن يتكون الاسم من حرفين على الأقل</span
                >
                <span v-if="!field.name4.maxLength"
                  >يجب أن يتكون الاسم من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="col-md-3 mb-3" label=" اللقب : " label-for="family_name">
              <b-form-input
                id="family_name"
                type="text"
                placeholder="ادخل اللقب"
                v-model.trim="field.family_name.$model"
                :class="{ 'is-invalid': field.family_name.$error }"
              ></b-form-input>
              <div v-if="field.family_name.$error" class="invalid-feedback">
                <span v-if="!field.family_name.required">هذا الحقل الزامي</span>
                <span v-if="!field.family_name.minLength"
                  >يجب أن يتكون اللقب من حرفين على الأقل</span
                >
                <span v-if="!field.family_name.maxLength"
                  >يجب أن يتكون اللقب من 15 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label="اسم الام الثلاثي : "
              label-for="mother_name"
            >
              <b-form-input
                id="mother_name"
                type="text"
                placeholder="ادخل اسم الام الثلاثي"
                v-model.trim="field.mother_name.$model"
                :class="{ 'is-invalid': field.mother_name.$error }"
              ></b-form-input>
              <div v-if="field.mother_name.$error" class="invalid-feedback">
                <span v-if="!field.mother_name.required">هذا الحقل الزامي</span>
                <span v-if="!field.mother_name.minLength"
                  >يجب أن يتكون اسم الام من حرفين على الأقل</span
                >
                <span v-if="!field.mother_name.maxLength"
                  >يجب أن يتكون اسم الام من 50 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-3 mb-3" label=" الجنس : " label-for="gender_id">
              <select
                class="form-control"
                id="gender_id"
                v-model.trim="field.gender_id.$model"
                :class="{ 'is-invalid': field.gender_id.$error }"
              >
                <option value="">اختر الجنس</option>
                <option v-for="gender in list_gender" :value="gender.id" :key="gender.id">
                  {{ gender.name }}
                </option>
              </select>
              <div v-if="field.gender_id.$error" class="invalid-feedback">
                <span v-if="!field.gender_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label=" صلة القرابه : "
              label-for="relative_relation_id"
            >
              <select
                class="form-control"
                id="relative_relation_id"
                v-model.trim="field.relative_relation_id.$model"
                :class="{ 'is-invalid': field.relative_relation_id.$error }"
              >
                <option value="">اختر صلة القرابه</option>
                <option
                  v-for="relative_relation in list_relative_relation"
                  :value="relative_relation.id"
                  :key="relative_relation.id"
                >
                  {{ relative_relation.name }}
                </option>
              </select>
              <div v-if="field.relative_relation_id.$error" class="invalid-feedback">
                <span v-if="!field.relative_relation_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group
              class="col-md-3 mb-3"
              label=" التحصيل الدراسي : "
              label-for="certificate_id"
            >
              <select
                class="form-control"
                id="certificate_id"
                v-model.trim="field.certificate_id.$model"
                :class="{ 'is-invalid': field.certificate_id.$error }"
              >
                <option value="">اختر التحصيل الدراسي</option>
                <option
                  v-for="certificate in list_certificate"
                  :value="certificate.id"
                  :key="certificate.id"
                >
                  {{ certificate.name }}
                </option>
              </select>
              <div v-if="field.certificate_id.$error" class="invalid-feedback">
                <span v-if="!field.certificate_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label=" التخصص الدراسي : "
              label-for="specialization"
            >
              <b-form-input
                id="specialization"
                type="text"
                placeholder="ادخل التخصص الدراسي"
                v-model.trim="field.specialization.$model"
                :class="{ 'is-invalid': field.specialization.$error }"
              ></b-form-input>
              <div v-if="field.specialization.$error" class="invalid-feedback">
                <span v-if="!field.specialization.required">هذا الحقل الزامي</span>
                <span v-if="!field.specialization.minLength"
                  >يجب أن يتكون التخصص الدراسي من حرفين على الأقل</span
                >
                <span v-if="!field.specialization.maxLength"
                  >يجب أن يتكون التخصص الدراسي من 50 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label=" رقم الهاتف 1 : "
              label-for="phone1"
            >
              <b-form-input
                id="phone1"
                type="number"
                placeholder="ادخل رقم الهاتف"
                v-model.trim="field.phone1.$model"
                :class="{ 'is-invalid': field.phone1.$error }"
              ></b-form-input>
              <div v-if="field.phone1.$error" class="invalid-feedback">
                <span v-if="!field.phone1.required">هذا الحقل الزامي</span>
                <span v-if="!field.phone1.minLength"
                  >يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span
                >
                <span v-if="!field.phone1.maxLength"
                  >يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label=" رقم الهاتف 2 : "
              label-for="phone2"
            >
              <b-form-input
                id="phone2"
                type="number"
                placeholder="ادخل رقم الهاتف"
                v-model.trim="field.phone2.$model"
                :class="{ 'is-invalid': field.phone2.$error }"
              ></b-form-input>
              <div v-if="field.phone2.$error" class="invalid-feedback">
                <span v-if="!field.phone2.minLength"
                  >يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span
                >
                <span v-if="!field.phone2.maxLength"
                  >يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group
              class="col-md-3 mb-3"
              label="تاريخ التولد : "
              label-for="birth_date"
            >
              <date-picker
                id="birth_date"
                type="date"
                lang="ar"
                value-type="DD-MM-YYYY"
                format="DD-MM-YYYY"
                placeholder="اختر تاريخ التولد"
                v-model.trim="field.birth_date.$model"
                :class="{ 'is-invalid': field.birth_date.$error }"
              ></date-picker>
              <div v-if="field.birth_date.$error" class="invalid-feedback">
                <span v-if="!field.birth_date.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label=" الحالة الاجتماعية : "
              label-for="marital_status_id"
            >
              <select
                class="form-control"
                id="marital_status_id"
                v-model.trim="field.marital_status_id.$model"
                :class="{ 'is-invalid': field.marital_status_id.$error }"
              >
                <option value="">اختر الحالة الاجتماعية</option>
                <option
                  v-for="marital_status in list_marital_status"
                  :value="marital_status.id"
                  :key="marital_status.id"
                >
                  {{ marital_status.name }}
                </option>
              </select>
              <div v-if="field.marital_status_id.$error" class="invalid-feedback">
                <span v-if="!field.marital_status_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-3 mb-3"
              label="اختر نوع البطاقة :"
              label-for="id_type"
            >
              <select
                class="form-control"
                id="id_type"
                v-model.trim="field.id_type.$model"
                :class="{ 'is-invalid': field.id_type.$error }"
              >
                <option value="">اختر البطاقة</option>
                <option value="1">بطاقة وطنية</option>
                <option value="2">هوية احوال مدنية</option>
              </select>
              <div v-if="field.id_type.$error" class="invalid-feedback">
                <span v-if="!field.id_type.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>

            <b-form-group
              v-if="getNationalityNumber(index)"
              class="col-md-3 mb-3"
              label="رقم البطاقة الوطنية :"
              label-for="nationality_number"
            >
              <b-form-input
                id="nationality_number"
                type="number"
                placeholder="ادخل رقم البطاقة الوطنية"
                v-model.trim="field.nationality_number.$model"
                :class="{ 'is-invalid': field.nationality_number.$error }"
              ></b-form-input>
              <div v-if="field.nationality_number.$error" class="invalid-feedback">
                <span v-if="!field.nationality_number.required">هذا الحقل الزامي</span>
                <span v-if="!field.nationality_number.minLength"
                  >يجب أن يتكون رقم البطاقة الوطنية من 12 رقم على الأقل</span
                >
                <span v-if="!field.nationality_number.maxLength"
                  >يجب أن يتكون رقم البطاقة الوطنية من 12 رقم على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group
              v-if="getNationalIdNumber(index)"
              class="col-md-3 mb-3"
              label="رقم هوية الاحوال المدنية :"
              label-for="national_id_number"
            >
              <b-form-input
                id="national_id_number"
                type="text"
                placeholder="ادخل رقم هوية الاحوال المدنية"
                v-model.trim="field.national_id_number.$model"
                :class="{ 'is-invalid': field.national_id_number.$error }"
              ></b-form-input>
              <div v-if="field.national_id_number.$error" class="invalid-feedback">
                <span v-if="!field.national_id_number.required">هذا الحقل الزامي</span>
                <span v-if="!field.national_id_number.numeric"
                  >يجب ان تكون قيمة هذا الحقل ارقاما فقط .
                </span>
                <span v-if="!field.national_id_number.minLength"
                  >يجب أن يتكون رقم هوية الاحوال المدنية من 8 رقم على الأقل</span
                >
                <span v-if="!field.national_id_number.maxLength"
                  >يجب أن يتكون رقم هوية الاحوال المدنية من 8 رقم على الاكثر</span
                >
              </div>
            </b-form-group>
          </div>
          <hr class="hr-title" />
          <div class="break-title"><h5 class="mb-4">المرفقات الثبوتية للمستفيد</h5></div>
          <ul class="li-attachments">
            <li>
              البطاقة الوطنية او ما يعادلها (هوية الاحوال المدنية + شهادة الجنسية) .
            </li>
            <li>البطاقة التموينية .</li>
            <li>بطاقة السكن .</li>
            <li>
              يجب جمع المرفقات الثبوتية للمستفيد اعلاه ورفعها بملف واحد بصيغة ( pdf. )
              وبحجم لا يتجاوز ( 2mb ) .
            </li>
          </ul>
          <div class="row">
            <b-form-group
              class="col-md-12 mb-3"
              label=" المرفقات الثبوتية للمستفيد :"
              :label-for="'attachment_beneficiary' + index"
            >
              <div class="custom_file">
                <b-form-file
                  :id="'attachment_beneficiary' + index"
                  class=""
                  :data-index="index"
                  placeholder="اختر المرفق"
                  accept=".pdf"
                  v-model.trim="field.attachment_beneficiary.$model"
                  @change="chnageFile"
                  :class="{ 'is-invalid': field.attachment_beneficiary.$error }"
                ></b-form-file>
                <div v-if="field.attachment_beneficiary.$error" class="invalid-feedback">
                  <span v-if="!field.attachment_beneficiary.required"
                    >هذا الحقل الزامي</span
                  >
                  <span v-if="!field.attachment_beneficiary.fileSize"
                    >يجب ان لا يتجاوز حجم الملف 2mb</span
                  >
                  <span v-if="!field.attachment_beneficiary.fileType"
                    >يجب ان يكون نوع الملف pdf</span
                  >
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="row">
            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-4">بيانات السكن للمستفيد</h5></div>

            <b-form-group
              class="col-md-6 mb-3"
              label=" نوع السكن  : "
              label-for="accommodation_id"
            >
              <select
                class="form-control"
                id="accommodation_id"
                v-model.trim="field.accommodation_id.$model"
                :class="{ 'is-invalid': field.accommodation_id.$error }"
              >
                <option value="">اختر نوع السكن</option>
                <option
                  v-for="accommodation in list_accommodation"
                  :value="accommodation.id"
                  :key="accommodation.id"
                >
                  {{ accommodation.name }}
                </option>
              </select>
              <div v-if="field.accommodation_id.$error" class="invalid-feedback">
                <span v-if="!field.accommodation_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group class="col-md-6 mb-3" label=" المحافظة  : " label-for="city_id">
              <select
                class="form-control"
                id="city_id"
                v-model.trim="field.city_id.$model"
                :class="{ 'is-invalid': field.city_id.$error }"
              >
                <option value="">اختر المحافظة</option>
                <option v-for="city in list_city" :value="city.id" :key="city.id">
                  {{ city.name }}
                </option>
              </select>
              <div v-if="field.city_id.$error" class="invalid-feedback">
                <span v-if="!field.city_id.required">هذا الحقل الزامي</span>
              </div>
            </b-form-group>
            <b-form-group class="col-md-6 mb-3" label="المنطقة : " label-for="region">
              <b-form-input
                id="region"
                type="text"
                placeholder="ادخل المنطقة"
                v-model.trim="field.region.$model"
                :class="{ 'is-invalid': field.region.$error }"
              ></b-form-input>
              <div v-if="field.region.$error" class="invalid-feedback">
                <span v-if="!field.region.required">هذا الحقل الزامي</span>
                <span v-if="!field.region.minLength"
                  >يجب أن تتكون المنطقة من حرفين على الأقل</span
                >
                <span v-if="!field.region.maxLength"
                  >يجب أن تتكون المنطقة من 50 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group
              class="col-md-6 mb-3"
              label="اقرب نقطة دالة : "
              label-for="nearest_point"
            >
              <b-form-input
                id="nearest_point"
                type="text"
                placeholder="ادخل اقرب نقطة دالة"
                v-model.trim="field.nearest_point.$model"
                :class="{ 'is-invalid': field.nearest_point.$error }"
              ></b-form-input>
              <div v-if="field.nearest_point.$error" class="invalid-feedback">
                <span v-if="!field.nearest_point.required">هذا الحقل الزامي</span>
                <span v-if="!field.nearest_point.minLength"
                  >يجب أن تكون اقرب نقطة دالة من حرفين على الأقل</span
                >
                <span v-if="!field.nearest_point.maxLength"
                  >يجب أن تكون اقرب نقطة دالة من 50 حرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-4 mb-3" label="المحلة : " label-for="mahla">
              <b-form-input
                id="mahla"
                type="text"
                placeholder="ادخل المحلة"
                v-model.trim="field.mahla.$model"
                :class="{ 'is-invalid': field.mahla.$error }"
              ></b-form-input>
              <div v-if="field.mahla.$error" class="invalid-feedback">
                <span v-if="!field.mahla.maxLength"
                  >يجب أن تكون المحلة من 10 احرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-4 mb-3" label="الزقاق : " label-for="zqaq">
              <b-form-input
                id="zqaq"
                type="text"
                placeholder="ادخل الزقاق"
                v-model.trim="field.zqaq.$model"
                :class="{ 'is-invalid': field.zqaq.$error }"
              ></b-form-input>
              <div v-if="field.zqaq.$error" class="invalid-feedback">
                <span v-if="!field.zqaq.maxLength"
                  >يجب أن يتكون الزقاق من 10 احرف على الاكثر</span
                >
              </div>
            </b-form-group>
            <b-form-group class="col-md-4 mb-3" label="الدار : " label-for="dar">
              <b-form-input
                id="dar"
                type="text"
                placeholder="ادخل الدار"
                v-model.trim="field.dar.$model"
                :class="{ 'is-invalid': field.dar.$error }"
              ></b-form-input>
              <div v-if="field.dar.$error" class="invalid-feedback">
                <span v-if="!field.dar.maxLength"
                  >يجب أن يتكون الدار من 10 احرف على الاكثر</span
                >
              </div>
            </b-form-group>

            <b-form-group
              class="col-md-12 mb-3"
              label=" حذف :"
              label-for=""
              v-if="fields.length > 1"
            >
              <div class="d-grid">
                <button
                  type="button"
                  class="btn btn-danger btn-block"
                  @click="deleteRowS(index)"
                >
                  <i class="bx bx-trash font-size-16 align-middle"></i>
                </button>
              </div>
            </b-form-group>

            <div class="col-lg-12"><hr class="mt-0" /></div>
          </div>
        </div>
        <input
          type="button"
          class="btn btn-primary mt-3 mb-3 mt-lg-0"
          style="width: 100%"
          value="اضافة مستفيد اخر"
          @click="AddformDataS"
        />
      </form>
    </div>
  </div>
  <!-- end page title -->
</template>
